export enum LabelPosition {
    No,
    Left,
    Right,
    Middle,
    Top,
    Bottom,
    FollowLeft,
    FollowRight,
    FollowTop,
    FollowBottom,
}
